import { show } from '@intercom/messenger-js-sdk'
import { MdHeadsetMic } from 'react-icons/md'

import { AMP_EVENT_NAME, trackAmpEvent } from '@/libs/configs/amplitude'
import { useAppDispatch } from '@/libs/hooks/use-app-dispatch'
import { useAppSelector } from '@/libs/hooks/use-app-selector'
import { toggleIntercom } from '@/libs/store/slice/ui-slice'

export default function HelpCenter() {
  const { showIntercom } = useAppSelector((state) => state.ui)
  const dispatch = useAppDispatch()

  const handleShowIntercom = () => {
    if (!showIntercom) {
      show()
      trackAmpEvent(AMP_EVENT_NAME.CLICK_HELP_CENTER, {
        'Page URL': window.location.href,
      })
      return dispatch(toggleIntercom(true))
    }
  }

  return (
    <button type='button' className='cursor-pointer ' onClick={handleShowIntercom}>
      <MdHeadsetMic width={18} height={22} className='text-2xl text-pop-grey-800' />
    </button>
  )
}
